import { render, staticRenderFns } from "./BalanceSheetYear.vue?vue&type=template&id=2a8dd640&scoped=true&"
import script from "./BalanceSheetYear.vue?vue&type=script&lang=js&"
export * from "./BalanceSheetYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8dd640",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a8dd640')) {
      api.createRecord('2a8dd640', component.options)
    } else {
      api.reload('2a8dd640', component.options)
    }
    module.hot.accept("./BalanceSheetYear.vue?vue&type=template&id=2a8dd640&scoped=true&", function () {
      api.rerender('2a8dd640', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/FinanceManage/UsaReport/BalanceSheetYear.vue"
export default component.exports